/*
  Iconic Blocks random text — theme fix (no global class redeclare).
  Patches the app custom element and adds the missing random message logic.
  Do not paste app source in the browser console; this file loads from the theme.
 */

(function () {
  'use strict';

  function parseSettings(raw) {
    try {
      return JSON.parse(raw || '{}');
    } catch (e) {
      return null;
    }
  }

  function getMessages(settings) {
    if (!settings) return [];

    const messages = [];
    for (let i = 1; i <= 10; i++) {
      const value = settings['random_text_' + i];
      if (value && String(value).trim()) {
        messages.push(String(value));
      }
    }
    return messages;
  }

  function getBlockId(root) {
    if (root.dataset.blockId) return root.dataset.blockId;
    if (root.id && root.id.indexOf('iconic-random-text-') === 0) {
      return root.id.replace('iconic-random-text-', '');
    }
    return '';
  }

  function injectStyles(blockId, settings) {
    if (!blockId) return;

    const styleId = 'iconic-random-text-styles-' + blockId;
    let style = document.getElementById(styleId);
    if (!style) {
      style = document.createElement('style');
      style.id = styleId;
      document.head.appendChild(style);
    }

    const mtb = settings.margin_top_bottom ?? 10;
    const color = settings.text_color || '#E63946';
    const fs = settings.text_font_size ?? 14;
    const transform = settings.text_transform || 'capitalize';

    style.textContent =
      '#iconic-random-text-' +
      blockId +
      ' {\n' +
      '  display: block;\n' +
      '  width: 100%;\n' +
      '  margin-top: ' +
      Math.round(mtb * 0.75) +
      'px;\n' +
      '  margin-bottom: ' +
      Math.round(mtb * 0.75) +
      'px;\n' +
      '}\n' +
      '#iconic-random-text-' +
      blockId +
      ' .iconic-product-random-text {\n' +
      '  color: ' +
      color +
      ';\n' +
      '  font-size: ' +
      Math.round(fs * 0.75) +
      'px;\n' +
      '  line-height: ' +
      (Math.round(fs * 0.75) + 5) +
      'px;\n' +
      '  text-transform: ' +
      transform +
      ';\n' +
      '}\n' +
      '@media screen and (min-width: 768px) {\n' +
      '  #iconic-random-text-' +
      blockId +
      ' {\n' +
      '    margin-top: ' +
      mtb +
      'px;\n' +
      '    margin-bottom: ' +
      mtb +
      'px;\n' +
      '  }\n' +
      '  #iconic-random-text-' +
      blockId +
      ' .iconic-product-random-text {\n' +
      '    font-size: ' +
      fs +
      'px;\n' +
      '    line-height: ' +
      (fs + 5) +
      'px;\n' +
      '  }\n' +
      '}';
  }

  function applyAlignment(target, settings) {
    const alignment = settings.text_alignment || 'start';
    target.classList.remove(
      'iconic-justify-content-start',
      'iconic-justify-content-center',
      'iconic-justify-content-end'
    );

    if (alignment === 'center') {
      target.classList.add('iconic-justify-content-center');
    } else if (alignment === 'end') {
      target.classList.add('iconic-justify-content-end');
    } else {
      target.classList.add('iconic-justify-content-start');
    }
  }

  function resolveSettings(root) {
    let settings = parseSettings(root.dataset.settings);
    if (settings && getMessages(settings).length) {
      return settings;
    }

    const host = root.closest('[data-iconic-random-text-host]');
    if (host) {
      const configEl = host.querySelector('[data-iconic-random-text-config]');
      if (configEl) {
        settings = parseSettings(configEl.textContent);
        if (settings) {
          root.dataset.settings = JSON.stringify(settings);
          return settings;
        }
      }
    }

    return settings || {};
  }

  function renderRandomText(root) {
    if (!root) return;

    const settings = resolveSettings(root);
    const messages = getMessages(settings);
    if (!messages.length) return;

    const blockId = getBlockId(root);
    const target = root.querySelector('.iconic-product-random-text');
    if (!target) return;

    injectStyles(blockId, settings);
    applyAlignment(target, settings);

    target.innerHTML = messages[Math.floor(Math.random() * messages.length)];
    root.dataset.iconicRandomTextReady = 'true';
  }

  function patchAppCustomElement() {
    const Existing = customElements.get('iconic-random-text');
    if (!Existing || Existing.prototype.__iconicThemeRandomTextFix) return;

    const originalConnected = Existing.prototype.connectedCallback;

    Existing.prototype.connectedCallback = function () {
      if (typeof originalConnected === 'function') {
        originalConnected.call(this);
      }
      renderRandomText(this);
    };

    Existing.prototype.__iconicThemeRandomTextFix = true;
  }

  function registerFallbackElement() {
    if (customElements.get('iconic-random-text')) return;

    customElements.define(
      'iconic-random-text',
      class extends HTMLElement {
        connectedCallback() {
          this.blockId = this.dataset.blockId || getBlockId(this);
          renderRandomText(this);
        }
      }
    );
  }

  function initAll() {
    document.querySelectorAll('[data-iconic-random-text], iconic-random-text').forEach(renderRandomText);
  }

  function boot() {
    patchAppCustomElement();
    registerFallbackElement();
    initAll();
    setTimeout(initAll, 400);
    setTimeout(initAll, 1200);
  }

  window.IconicRandomTextInit = renderRandomText;
  window.IconicRandomTextBoot = boot;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
